import { ACCOUNT_REF_ID_CACHE_KEY, useGetAccountReferenceIdMutation } from ".";
import useAppSelector from "../../hooks/useAppSelector";
import { useCallback } from "react";
export default function useAccountReferenceId() {
    var _a = useGetAccountReferenceIdMutation({
        fixedCacheKey: ACCOUNT_REF_ID_CACHE_KEY,
    }), getAccountReferenceId = _a[0], status = _a[1].status;
    var savvyConnectionIdFromState = useAppSelector(function (_a) {
        var applicant = _a.applicant;
        return applicant.savvyConnectionId;
    });
    var connectionId = useAppSelector(function (state) {
        var _a = state.auth, auto = _a.auto, home = _a.home;
        return auto.accountInfo.connectionId || home.accountInfo.connectionId;
    });
    var memodGetAccountReferenceId = useCallback(function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.accountConnectionId, accountConnectionId = _c === void 0 ? connectionId : _c, _d = _b.savvyConnectionId, savvyConnectionId = _d === void 0 ? savvyConnectionIdFromState : _d;
        return getAccountReferenceId({
            accountConnectionId: accountConnectionId,
            savvyConnectionId: savvyConnectionId,
        });
    }, [getAccountReferenceId, connectionId, savvyConnectionIdFromState]);
    return { getAccountReferenceId: memodGetAccountReferenceId, status: status };
}
